import { Host, h } from '@stencil/core';
export class AibaQuiz {
  constructor() {
    this.getselectedOptions = questionId => {
      let selectedoptions = [];
      if (this.selectedOptionsWithId && Object.keys(this.selectedOptionsWithId).length > 0) {
        selectedoptions = this.selectedOptionsWithId[questionId] ? [...this.selectedOptionsWithId[questionId]] : [];
      }
      else {
        selectedoptions = this.selectedOptions ? [...this.selectedOptions] : [];
      }
      return selectedoptions;
    };
    this.data = undefined;
    this.handlers = undefined;
    this.classes = undefined;
    this.styles = undefined;
    this.selectedOptions = undefined;
    this.totalQuestions = undefined;
    this.quizPlainIndex = undefined;
    this.index = undefined;
    this.state = undefined;
    this.answers = undefined;
    this.error = false;
    this.helpModal = false;
    this.selectedOptionsWithId = undefined;
    this.enableQuestionInfoOnOptionsDiv = false;
    this.hideNextButton = 'none';
    this.quizScreenLoading = undefined;
  }
  enableError(event) {
    this.error = (event === null || event === void 0 ? void 0 : event.detail) ? event === null || event === void 0 ? void 0 : event.detail : true;
  }
  singleOptionNextClick(event) {
    let hideNextButton = event.detail['hideNextButton'];
    let continueRef, analyseRef;
    switch (hideNextButton) {
      case 'showOnFirstQuestion':
        continueRef = this.parentRef.querySelector('.quiz-continue-button button');
        analyseRef = this.parentRef.querySelector('.quiz-analyse-button button');
        setTimeout(() => {
          continueRef === null || continueRef === void 0 ? void 0 : continueRef.click();
          analyseRef === null || analyseRef === void 0 ? void 0 : analyseRef.click();
        }, 500);
        break;
      case 'none':
        continueRef = this.parentRef.querySelector('.quiz-continue-button button');
        analyseRef = this.parentRef.querySelector('.quiz-analyse-button button');
        setTimeout(() => {
          continueRef === null || continueRef === void 0 ? void 0 : continueRef.click();
          analyseRef === null || analyseRef === void 0 ? void 0 : analyseRef.click();
        }, 500);
        break;
      default:
        break;
    }
  }
  disableError() {
    this.error = '';
  }
  toggleLoading(event) {
    let loaderName = event['detail']['loaderName'];
    let value = event['detail']['value'];
    this[loaderName] = value;
  }
  helpModalTogle(event) {
    let value = event['detail']['value'];
    this.helpModal = value;
  }
  componentDidLoad() {
    var _a, _b;
    this.handlers && ((_a = this === null || this === void 0 ? void 0 : this.handlers) === null || _a === void 0 ? void 0 : _a.quizDidLoadhandler) && ((_b = this === null || this === void 0 ? void 0 : this.handlers) === null || _b === void 0 ? void 0 : _b.quizDidLoadhandler());
  }
  componentDidRender() {
    var _a, _b;
    this.handlers && ((_a = this === null || this === void 0 ? void 0 : this.handlers) === null || _a === void 0 ? void 0 : _a.quizDidRenderHandler) && ((_b = this === null || this === void 0 ? void 0 : this.handlers) === null || _b === void 0 ? void 0 : _b.quizDidRenderHandler());
  }
  handleAnalyzeQuestionClick(event) {
    this.handlers && this.handlers.handleAnalyzeQuestionClick && this.handlers.handleAnalyzeQuestionClick(event);
  }
  handleNextQuestionClick(event) {
    this.handlers && this.handlers.handleNextQuestionClick && this.handlers.handleNextQuestionClick(event);
  }
  render() {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26, _27, _28, _29, _30, _31, _32, _33, _34, _35, _36, _37, _38, _39, _40, _41, _42, _43, _44, _45, _46, _47, _48, _49, _50, _51, _52, _53, _54, _55, _56, _57, _58, _59, _60, _61, _62, _63, _64, _65, _66, _67, _68, _69, _70, _71, _72, _73, _74, _75, _76, _77, _78, _79, _80, _81, _82, _83, _84, _85, _86, _87, _88, _89, _90, _91, _92, _93, _94, _95, _96, _97, _98, _99, _100, _101, _102, _103, _104, _105, _106, _107, _108, _109, _110, _111, _112, _113, _114, _115, _116, _117, _118, _119, _120, _121, _122, _123, _124, _125, _126, _127, _128, _129, _130, _131, _132, _133, _134, _135, _136, _137, _138, _139, _140, _141, _142, _143, _144, _145, _146, _147, _148, _149, _150, _151, _152, _153, _154, _155, _156, _157, _158, _159, _160, _161, _162, _163, _164, _165, _166, _167, _168, _169, _170, _171, _172, _173, _174, _175, _176, _177, _178, _179, _180, _181, _182, _183;
    if (typeof this.data === 'string') {
      this.data = JSON.parse(this.data);
    }
    const selectedQuestions = this.getselectedOptions((_b = (_a = this.data.questions[this.index]) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.questionId);
    const groupId = ((_e = (_d = (_c = this.data) === null || _c === void 0 ? void 0 : _c.questions[this.index]) === null || _d === void 0 ? void 0 : _d.data) === null || _e === void 0 ? void 0 : _e.groupId) ? (_h = (_g = (_f = this.data) === null || _f === void 0 ? void 0 : _f.questions[this.index]) === null || _g === void 0 ? void 0 : _g.data) === null || _h === void 0 ? void 0 : _h.groupId : '';
    return (h(Host, null, this.styles && h("style", null, this.styles), ((_k = (_j = this.data) === null || _j === void 0 ? void 0 : _j.questions[this.index]) === null || _k === void 0 ? void 0 : _k.styles) && h("style", null, (_m = (_l = this.data) === null || _l === void 0 ? void 0 : _l.questions[this.index]) === null || _m === void 0 ? void 0 : _m.styles), h("div", { ref: el => (this.parentRef = el), class: `quiz-wrapper-div ${groupId}` }, h("aiba-quiz-question", { data: (_p = (_o = this.data) === null || _o === void 0 ? void 0 : _o.questions[this.index]) === null || _p === void 0 ? void 0 : _p.data, classes: (_r = (_q = this.data) === null || _q === void 0 ? void 0 : _q.questions[this.index]) === null || _r === void 0 ? void 0 : _r.classes, index: Number(this.quizPlainIndex), total: this.totalQuestions, handlers: this.handlers }), ((_s = this === null || this === void 0 ? void 0 : this.data) === null || _s === void 0 ? void 0 : _s.questionImages) && ((_t = this === null || this === void 0 ? void 0 : this.data) === null || _t === void 0 ? void 0 : _t.questionImages[this.index]) && h("img", Object.assign({ class: "question-icon" }, (_u = this === null || this === void 0 ? void 0 : this.data) === null || _u === void 0 ? void 0 : _u.questionImages[this.index])), ((_x = (_w = (_v = this.data) === null || _v === void 0 ? void 0 : _v.questions[this.index]) === null || _w === void 0 ? void 0 : _w.data) === null || _x === void 0 ? void 0 : _x.quizTips) && (h("div", { class: "quiz-tips" }, (_0 = (_z = (_y = this.data) === null || _y === void 0 ? void 0 : _y.questions[this.index]) === null || _z === void 0 ? void 0 : _z.data) === null || _0 === void 0 ? void 0 :
      _0.quizTips.elements.map((element) => {
        if (element.name === 'aiba-button')
          return h("aiba-button", Object.assign({}, element['data'], { handleClick: (event) => this.handlers && this.handlers.quizTipClick(event) }));
      }), h("aiba-modal", { handlers: this.handlers, closeButtonData: (_5 = (_4 = (_3 = (_2 = (_1 = this.data) === null || _1 === void 0 ? void 0 : _1.questions[this.index]) === null || _2 === void 0 ? void 0 : _2.data) === null || _3 === void 0 ? void 0 : _3.quizTips) === null || _4 === void 0 ? void 0 : _4.modalData) === null || _5 === void 0 ? void 0 : _5.closeButtonData, modalPosition: (_10 = (_9 = (_8 = (_7 = (_6 = this.data) === null || _6 === void 0 ? void 0 : _6.questions[this.index]) === null || _7 === void 0 ? void 0 : _7.data) === null || _8 === void 0 ? void 0 : _8.quizTips) === null || _9 === void 0 ? void 0 : _9.modalData) === null || _10 === void 0 ? void 0 : _10.modalPosition }, (_16 = (_15 = (_14 = (_13 = (_12 = (_11 = this.data) === null || _11 === void 0 ? void 0 : _11.questions[this.index]) === null || _12 === void 0 ? void 0 : _12.data) === null || _13 === void 0 ? void 0 : _13.quizTips) === null || _14 === void 0 ? void 0 : _14.modalData) === null || _15 === void 0 ? void 0 : _15.data) === null || _16 === void 0 ? void 0 :
      _16.elements.map((element) => {
        if (element.name === 'aiba-generic-block')
          return h("aiba-generic-block", { data: element['data'] });
      }), h("div", { class: "background" })))), ((_17 = this === null || this === void 0 ? void 0 : this.data) === null || _17 === void 0 ? void 0 : _17.questions) && (h("div", { class: "quiz-lower-half-wrapper" }, this.enableQuestionInfoOnOptionsDiv && (h("aiba-label", Object.assign({ tag: "h3", setInnerHTML: true, innerHTML: (_19 = (_18 = this === null || this === void 0 ? void 0 : this.data) === null || _18 === void 0 ? void 0 : _18.questionInfos[this.index]) === null || _19 === void 0 ? void 0 : _19.text }, (_20 = this === null || this === void 0 ? void 0 : this.data) === null || _20 === void 0 ? void 0 : _20.questionInfos[this.index]))), h("aiba-quiz-option", { type: (_24 = (_23 = (_22 = (_21 = this === null || this === void 0 ? void 0 : this.data) === null || _21 === void 0 ? void 0 : _21.questions[this.index]) === null || _22 === void 0 ? void 0 : _22.data) === null || _23 === void 0 ? void 0 : _23.answers) === null || _24 === void 0 ? void 0 : _24.type, options: (_28 = (_27 = (_26 = (_25 = this === null || this === void 0 ? void 0 : this.data) === null || _25 === void 0 ? void 0 : _25.questions[this.index]) === null || _26 === void 0 ? void 0 : _26.data) === null || _27 === void 0 ? void 0 : _27.answers) === null || _28 === void 0 ? void 0 : _28.data, selectedOptions: selectedQuestions, maxSelection: (_32 = (_31 = (_30 = (_29 = this === null || this === void 0 ? void 0 : this.data) === null || _29 === void 0 ? void 0 : _29.questions[this.index]) === null || _30 === void 0 ? void 0 : _30.data) === null || _31 === void 0 ? void 0 : _31.answers) === null || _32 === void 0 ? void 0 : _32.maxSelection, handlers: this.handlers, optionClasses: `quiz-input-container ${this.error && 'error-block'}`, variant: (_36 = (_35 = (_34 = (_33 = this === null || this === void 0 ? void 0 : this.data) === null || _33 === void 0 ? void 0 : _33.questions[this.index]) === null || _34 === void 0 ? void 0 : _34.data) === null || _35 === void 0 ? void 0 : _35.answers) === null || _36 === void 0 ? void 0 : _36.variant, questionId: (_38 = (_37 = this.data.questions[this.index]) === null || _37 === void 0 ? void 0 : _37.data) === null || _38 === void 0 ? void 0 : _38.questionId, hideNextButton: this.hideNextButton ? this.hideNextButton : 'none', placeholder: ((_42 = (_41 = (_40 = (_39 = this === null || this === void 0 ? void 0 : this.data) === null || _39 === void 0 ? void 0 : _39.questions[this.index]) === null || _40 === void 0 ? void 0 : _40.data) === null || _41 === void 0 ? void 0 : _41.answers) === null || _42 === void 0 ? void 0 : _42.placeholder) ? (_46 = (_45 = (_44 = (_43 = this === null || this === void 0 ? void 0 : this.data) === null || _43 === void 0 ? void 0 : _43.questions[this.index]) === null || _44 === void 0 ? void 0 : _44.data) === null || _45 === void 0 ? void 0 : _45.answers) === null || _46 === void 0 ? void 0 : _46.placeholder : '' }), ((_49 = (_48 = (_47 = this.data) === null || _47 === void 0 ? void 0 : _47.questions[this.index]) === null || _48 === void 0 ? void 0 : _48.data) === null || _49 === void 0 ? void 0 : _49.quizHelp) && (h("div", { class: "quiz-helps" }, (_52 = (_51 = (_50 = this.data) === null || _50 === void 0 ? void 0 : _50.questions[this.index]) === null || _51 === void 0 ? void 0 : _51.data) === null || _52 === void 0 ? void 0 :
      _52.quizHelp.elements.map((element) => {
        if (element.name === 'aiba-button')
          return h("aiba-button", Object.assign({}, element['data'], { handleClick: (event) => this.handlers && this.handlers.quizHelpClick(event) }));
      }), this.helpModal && (h("aiba-modal", { handlers: this.handlers, closeButtonData: (_57 = (_56 = (_55 = (_54 = (_53 = this.data) === null || _53 === void 0 ? void 0 : _53.questions[this.index]) === null || _54 === void 0 ? void 0 : _54.data) === null || _55 === void 0 ? void 0 : _55.quizHelp) === null || _56 === void 0 ? void 0 : _56.modalData) === null || _57 === void 0 ? void 0 : _57.closeButtonData, modalPosition: (_62 = (_61 = (_60 = (_59 = (_58 = this.data) === null || _58 === void 0 ? void 0 : _58.questions[this.index]) === null || _59 === void 0 ? void 0 : _59.data) === null || _60 === void 0 ? void 0 : _60.quizHelp) === null || _61 === void 0 ? void 0 : _61.modalData) === null || _62 === void 0 ? void 0 : _62.modalPosition }, (_68 = (_67 = (_66 = (_65 = (_64 = (_63 = this.data) === null || _63 === void 0 ? void 0 : _63.questions[this.index]) === null || _64 === void 0 ? void 0 : _64.data) === null || _65 === void 0 ? void 0 : _65.quizHelp) === null || _66 === void 0 ? void 0 : _66.modalData) === null || _67 === void 0 ? void 0 : _67.data) === null || _68 === void 0 ? void 0 :
      _68.elements.map((element) => {
        if (element.name === 'aiba-generic-block')
          return h("aiba-generic-block", { data: element['data'] });
      }), h("div", { class: "background" }))))), this.error && (h("aiba-label", { classes: ((_70 = (_69 = this.data) === null || _69 === void 0 ? void 0 : _69.error) === null || _70 === void 0 ? void 0 : _70.errorLabelClasses) ? (_72 = (_71 = this.data) === null || _71 === void 0 ? void 0 : _71.error) === null || _72 === void 0 ? void 0 : _72.errorLabelClasses : ' quizerror', styles: (_74 = (_73 = this.data) === null || _73 === void 0 ? void 0 : _73.error) === null || _74 === void 0 ? void 0 : _74.errorStyles, tag: "span", text: this.error !== 'required' ? this.error : (_77 = (_76 = (_75 = this === null || this === void 0 ? void 0 : this.data) === null || _75 === void 0 ? void 0 : _75.questions[this.index]) === null || _76 === void 0 ? void 0 : _76.data) === null || _77 === void 0 ? void 0 : _77.questionMandatory })), h("div", { class: "quiz-button-container" }, h("aiba-button", Object.assign({ handleClick: event => this.handlers && this.handlers.handlePrevQuestionClick && this.handlers.handlePrevQuestionClick(event) }, (_79 = (_78 = this.data) === null || _78 === void 0 ? void 0 : _78.prev) === null || _79 === void 0 ? void 0 : _79.data, { iconOnly: (_82 = (_81 = (_80 = this.data) === null || _80 === void 0 ? void 0 : _80.prev) === null || _81 === void 0 ? void 0 : _81.data) === null || _82 === void 0 ? void 0 : _82.iconOnly, path: (_85 = (_84 = (_83 = this.data) === null || _83 === void 0 ? void 0 : _83.prev) === null || _84 === void 0 ? void 0 : _84.data) === null || _85 === void 0 ? void 0 : _85.path, pathWithHover: (_88 = (_87 = (_86 = this.data) === null || _86 === void 0 ? void 0 : _86.prev) === null || _87 === void 0 ? void 0 : _87.data) === null || _88 === void 0 ? void 0 : _88.pathWithHover, styles: (_91 = (_90 = (_89 = this.data) === null || _89 === void 0 ? void 0 : _89.prev) === null || _90 === void 0 ? void 0 : _90.data) === null || _91 === void 0 ? void 0 : _91.styles, value: (_94 = (_93 = (_92 = this.data) === null || _92 === void 0 ? void 0 : _92.prev) === null || _93 === void 0 ? void 0 : _93.data) === null || _94 === void 0 ? void 0 : _94.title, variant: (_97 = (_96 = (_95 = this.data) === null || _95 === void 0 ? void 0 : _95.prev) === null || _96 === void 0 ? void 0 : _96.data) === null || _97 === void 0 ? void 0 : _97.variant, upperCase: (_100 = (_99 = (_98 = this.data) === null || _98 === void 0 ? void 0 : _98.prev) === null || _99 === void 0 ? void 0 : _99.data) === null || _100 === void 0 ? void 0 : _100.upperCase, arialabel: ((_103 = (_102 = (_101 = this.data) === null || _101 === void 0 ? void 0 : _101.prev) === null || _102 === void 0 ? void 0 : _102.data) === null || _103 === void 0 ? void 0 : _103.title) ? (_106 = (_105 = (_104 = this.data) === null || _104 === void 0 ? void 0 : _104.prev) === null || _105 === void 0 ? void 0 : _105.data) === null || _106 === void 0 ? void 0 : _106.title : (_109 = (_108 = (_107 = this.data) === null || _107 === void 0 ? void 0 : _107.prev) === null || _108 === void 0 ? void 0 : _108.data) === null || _109 === void 0 ? void 0 : _109.arialabel, disabled: (_112 = (_111 = (_110 = this.data) === null || _110 === void 0 ? void 0 : _110.prev) === null || _111 === void 0 ? void 0 : _111.data) === null || _112 === void 0 ? void 0 : _112.disabled })), this.data.analyze && Number(this === null || this === void 0 ? void 0 : this.totalQuestions) === Number(this === null || this === void 0 ? void 0 : this.quizPlainIndex) ? (h("aiba-button", Object.assign({ handleClick: event => this.handleAnalyzeQuestionClick(event) }, (_114 = (_113 = this.data) === null || _113 === void 0 ? void 0 : _113.analyze) === null || _114 === void 0 ? void 0 : _114.data, { styles: (_117 = (_116 = (_115 = this.data) === null || _115 === void 0 ? void 0 : _115.analyze) === null || _116 === void 0 ? void 0 : _116.data) === null || _117 === void 0 ? void 0 : _117.styles, textOnly: (_120 = (_119 = (_118 = this.data) === null || _118 === void 0 ? void 0 : _118.analyze) === null || _119 === void 0 ? void 0 : _119.data) === null || _120 === void 0 ? void 0 : _120.textOnly, value: (_123 = (_122 = (_121 = this.data) === null || _121 === void 0 ? void 0 : _121.analyze) === null || _122 === void 0 ? void 0 : _122.data) === null || _123 === void 0 ? void 0 : _123.title, variant: (_126 = (_125 = (_124 = this.data) === null || _124 === void 0 ? void 0 : _124.analyze) === null || _125 === void 0 ? void 0 : _125.data) === null || _126 === void 0 ? void 0 : _126.variant, upperCase: (_129 = (_128 = (_127 = this.data) === null || _127 === void 0 ? void 0 : _127.analyze) === null || _128 === void 0 ? void 0 : _128.data) === null || _129 === void 0 ? void 0 : _129.upperCase, path: (_132 = (_131 = (_130 = this.data) === null || _130 === void 0 ? void 0 : _130.analyze) === null || _131 === void 0 ? void 0 : _131.data) === null || _132 === void 0 ? void 0 : _132.path, pathWithHover: (_135 = (_134 = (_133 = this.data) === null || _133 === void 0 ? void 0 : _133.analyze) === null || _134 === void 0 ? void 0 : _134.data) === null || _135 === void 0 ? void 0 : _135.pathWithHover, arialabel: (_138 = (_137 = (_136 = this.data) === null || _136 === void 0 ? void 0 : _136.analyze) === null || _137 === void 0 ? void 0 : _137.data) === null || _138 === void 0 ? void 0 : _138.title, disabled: (_141 = (_140 = (_139 = this.data) === null || _139 === void 0 ? void 0 : _139.analyze) === null || _140 === void 0 ? void 0 : _140.data) === null || _141 === void 0 ? void 0 : _141.disabled, classes: ((_144 = (_143 = (_142 = this.data) === null || _142 === void 0 ? void 0 : _142.analyze) === null || _143 === void 0 ? void 0 : _143.data) === null || _144 === void 0 ? void 0 : _144.classes) ? (_147 = (_146 = (_145 = this.data) === null || _145 === void 0 ? void 0 : _145.analyze) === null || _146 === void 0 ? void 0 : _146.data) === null || _147 === void 0 ? void 0 : _147.classes : ' quiz-button', class: `${this.hideNextButton === 'showOnFirstQuestion' ? 'hidden' : ''} quiz-analyse-button` }))) : (h("aiba-button", Object.assign({ handleClick: event => this.handleNextQuestionClick(event) }, (_149 = (_148 = this.data) === null || _148 === void 0 ? void 0 : _148.next) === null || _149 === void 0 ? void 0 : _149.data, { styles: (_152 = (_151 = (_150 = this.data) === null || _150 === void 0 ? void 0 : _150.next) === null || _151 === void 0 ? void 0 : _151.data) === null || _152 === void 0 ? void 0 : _152.styles, textOnly: (_155 = (_154 = (_153 = this.data) === null || _153 === void 0 ? void 0 : _153.next) === null || _154 === void 0 ? void 0 : _154.data) === null || _155 === void 0 ? void 0 : _155.textOnly, value: (_158 = (_157 = (_156 = this.data) === null || _156 === void 0 ? void 0 : _156.next) === null || _157 === void 0 ? void 0 : _157.data) === null || _158 === void 0 ? void 0 : _158.title, variant: (_161 = (_160 = (_159 = this.data) === null || _159 === void 0 ? void 0 : _159.next) === null || _160 === void 0 ? void 0 : _160.data) === null || _161 === void 0 ? void 0 : _161.variant, path: (_164 = (_163 = (_162 = this.data) === null || _162 === void 0 ? void 0 : _162.next) === null || _163 === void 0 ? void 0 : _163.data) === null || _164 === void 0 ? void 0 : _164.path, pathWithHover: (_167 = (_166 = (_165 = this.data) === null || _165 === void 0 ? void 0 : _165.next) === null || _166 === void 0 ? void 0 : _166.data) === null || _167 === void 0 ? void 0 : _167.pathWithHover, upperCase: (_170 = (_169 = (_168 = this.data) === null || _168 === void 0 ? void 0 : _168.next) === null || _169 === void 0 ? void 0 : _169.data) === null || _170 === void 0 ? void 0 : _170.upperCase, classes: ((_173 = (_172 = (_171 = this.data) === null || _171 === void 0 ? void 0 : _171.next) === null || _172 === void 0 ? void 0 : _172.data) === null || _173 === void 0 ? void 0 : _173.classes) ? (_176 = (_175 = (_174 = this.data) === null || _174 === void 0 ? void 0 : _174.next) === null || _175 === void 0 ? void 0 : _175.data) === null || _176 === void 0 ? void 0 : _176.classes : ' quiz-button', arialabel: (_179 = (_178 = (_177 = this.data) === null || _177 === void 0 ? void 0 : _177.next) === null || _178 === void 0 ? void 0 : _178.data) === null || _179 === void 0 ? void 0 : _179.title, disabled: (_182 = (_181 = (_180 = this.data) === null || _180 === void 0 ? void 0 : _180.next) === null || _181 === void 0 ? void 0 : _181.data) === null || _182 === void 0 ? void 0 : _182.disabled, class: `${this.hideNextButton === 'showOnFirstQuestion' ? ((this === null || this === void 0 ? void 0 : this.quizPlainIndex) === 1 ? '' : 'hidden') : ''} quiz-continue-button` }))))))), ((_183 = this.data) === null || _183 === void 0 ? void 0 : _183.modals) && (h("div", { class: "modals-wrapper" }, this.data.modals['elements'] &&
      this.data.modals['elements'].map((modalElem) => {
        if (modalElem && modalElem['name'] === 'aiba-loading-modal') {
          return (this.quizScreenLoading && (h("aiba-modal", Object.assign({}, modalElem['data']), h("aiba-spinner", Object.assign({}, Object.assign({}, modalElem['spinner']))))));
        }
      })))));
  }
  static get is() { return "aiba-quiz"; }
  static get originalStyleUrls() {
    return {
      "$": ["aiba-quiz.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["aiba-quiz.css"]
    };
  }
  static get properties() {
    return {
      "data": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "data",
        "reflect": false
      },
      "handlers": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "handlers",
        "reflect": false
      },
      "classes": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "classes",
        "reflect": false
      },
      "styles": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "styles",
        "reflect": false
      },
      "selectedOptions": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "selected-options",
        "reflect": false
      },
      "totalQuestions": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "total-questions",
        "reflect": false
      },
      "quizPlainIndex": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "quiz-plain-index",
        "reflect": false
      },
      "index": {
        "type": "number",
        "mutable": false,
        "complexType": {
          "original": "number",
          "resolved": "number",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "index",
        "reflect": false
      },
      "selectedOptionsWithId": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "selected-options-with-id",
        "reflect": false
      },
      "enableQuestionInfoOnOptionsDiv": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "enable-question-info-on-options-div",
        "reflect": false,
        "defaultValue": "false"
      },
      "hideNextButton": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "'showOnFirstQuestion' | 'hideTillAnswerSelected' | 'none'",
          "resolved": "\"hideTillAnswerSelected\" | \"none\" | \"showOnFirstQuestion\"",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "hide-next-button",
        "reflect": false,
        "defaultValue": "'none'"
      }
    };
  }
  static get states() {
    return {
      "state": {},
      "answers": {},
      "error": {},
      "helpModal": {},
      "quizScreenLoading": {}
    };
  }
  static get listeners() {
    return [{
        "name": "event-options-error",
        "method": "enableError",
        "target": "window",
        "capture": true,
        "passive": false
      }, {
        "name": "singleOptionSelected",
        "method": "singleOptionNextClick",
        "target": "window",
        "capture": true,
        "passive": false
      }, {
        "name": "event-quizscreen",
        "method": "disableError",
        "target": "window",
        "capture": true,
        "passive": false
      }, {
        "name": "toggle-quiz-screen-loading",
        "method": "toggleLoading",
        "target": "window",
        "capture": false,
        "passive": false
      }, {
        "name": "help-modal-toggle",
        "method": "helpModalTogle",
        "target": "window",
        "capture": true,
        "passive": false
      }];
  }
}
//# sourceMappingURL=aiba-quiz.js.map
